module.exports = __webpack_public_path__ + "img/phone-in-hand.e1eb7fe8.png";